/**
 * Format duration in seconds to MM:SS format
 * @param seconds - Duration in seconds
 * @returns Formatted string like "14:21"
 */
export function formatDuration(seconds: number): string {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs.toString().padStart(2, '0')}`;
}

/**
 * Format duration with label for display
 * @param seconds - Duration in seconds
 * @returns Formatted string like "(14:21 mins)"
 */
export function formatDurationWithLabel(seconds: number): string {
    return `(${formatDuration(seconds)} mins)`;
}
